import { render, staticRenderFns } from "./PropertyPortalSummary.vue?vue&type=template&id=54390bd1&scoped=true"
import script from "./PropertyPortalSummary.vue?vue&type=script&lang=js"
export * from "./PropertyPortalSummary.vue?vue&type=script&lang=js"
import style0 from "./PropertyPortalSummary.vue?vue&type=style&index=0&id=54390bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54390bd1",
  null
  
)

export default component.exports